import { render, staticRenderFns } from "./royalty-plan-list.vue?vue&type=template&id=6e6b5a50&scoped=true&"
import script from "./royalty-plan-list.vue?vue&type=script&lang=js&"
export * from "./royalty-plan-list.vue?vue&type=script&lang=js&"
import style0 from "./royalty-plan-list.vue?vue&type=style&index=0&id=6e6b5a50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6b5a50",
  null
  
)

export default component.exports